module.exports = __webpack_public_path__ + "static/media/top-banner.d2ede0a9.jpg";